@if (type === 'mat') {
  <mat-radio-button
    [name]="name"
    [value]="value"
    [disabled]="disabled"
    (change)="onchange($event)">
    @if (label) {
      {{ label }}
    }
  </mat-radio-button>
} @else {
  <label class="d-flex align-items-center">
    <input
      [name]="name"
      [value]="value"
      type="radio"
      [(ngModel)]="input"
      [disabled]="disabled"
      (ngModelChange)="onchange($event)"
    >
    <span class="ps-2">{{ label }}</span>
  </label>
}



